import { render, staticRenderFns } from "./CreateVehicleType.vue?vue&type=template&id=7623f37b&"
import script from "./CreateVehicleType.vue?vue&type=script&lang=js&"
export * from "./CreateVehicleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports